import { useTranslation } from "react-i18next";
import Currency from "@enums/currency";
import { SceneCrypto as SceneCryptoType } from "@ltypes/scene";
import DisplayForm from "@components/forms/DisplayForm/DisplayForm";
import List, { ListItemType } from "@components/forms/List/List";
import Select from "@components/forms/Select/Select";
import TextField from "@components/forms/TextField/TextField";
import { useSelector } from "react-redux";
import Product, { ProductModelType } from "@ltypes/product";
import { displayModes } from "../../../constants";
import Coin from "@ltypes/asset";

type SceneCryptoProps = {
    scene: SceneCryptoType,
    onChange: (field: string, value: any) => void,
};

function SceneCrypto(props: SceneCryptoProps) {

    const { t } = useTranslation();
    const product: Product = useSelector((state: any) => state.product);
    const coinsList: Array<Coin> = useSelector((state: any) => state.crypto);

    const coinsAvailable: Array<ListItemType> = coinsList.map((coin: Coin) => ({
        label: coin.symbol,
        value: coin.symbol,
        description: coin.name,
        disabled: !coin.active,
    }));

    const getCurrencyLabel = (currency: string) => {
        if (currency in Currency) {
            return Currency[currency as keyof typeof Currency];
        }
        return '???';
    };

    return (
        <div className="row g-3">
            <div className="col-12 col-md-6">
                <div className="row g-3">
                    <div className="col-12">
                        <DisplayForm label={t('page.scenes.data.display_mode')} value={props.scene.display_mode} items={displayModes[product.model.type].crypto.map((index: number) => ({
                            id: index,
                            background: `crypto-${index}`,
                        }))} productModelType={product.model.type} onChange={(value: number) => props.onChange('display_mode', value)}/>
                    </div>
                    <div className="col-12">
                        <TextField label={product.model.type === ProductModelType.LEGACY || ![1,2].includes(props.scene.display_mode) ? t('page.scenes.data.display_duration_coin') : t('page.scenes.data.display_duration')} value={props.scene.display_duration} onChange={(value: string) => props.onChange('display_duration', value)}/>
                    </div>
                    <div className="col-12">
                        <Select label={t('page.scenes.data.currency')} value={props.scene.currency} items={Object.keys(Currency).map((currency: string) => ({
                            label: getCurrencyLabel(currency),
                            value: currency,
                        }))} onChange={(value: string) => props.onChange('currency', value)}/>
                    </div>
                    {product.model.type === ProductModelType.STANDARD && props.scene.display_mode === 3 && (
                        <div className="col-12">
                            <Select label={t('page.scenes.data.candlestick_interval')} value={props.scene.interval ?? 15} items={[15,30,60].map((interval: number) => ({
                                label: `${interval}min`,
                                value: interval,
                            }))} onChange={(value: string) => props.onChange('interval', value)}/>
                        </div>
                    )}
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="row g-3">
                    <div className="col-12 col-md-8">
                        <List label={t('page.scenes.data.coins')} values={props.scene.coins ?? []} items={coinsAvailable} iconPath={`${process.env.REACT_APP_API_URL}/media/coins/`} onChange={(values: Array<string>) => props.onChange('coins', values)}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SceneCrypto;
